import { render, staticRenderFns } from "./TicketsFeed.vue?vue&type=template&id=c944b85a&scoped=true&"
import script from "./TicketsFeed.vue?vue&type=script&lang=ts&"
export * from "./TicketsFeed.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsFeed.vue?vue&type=style&index=0&id=c944b85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c944b85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
